<template>
    <div>
        <Checkbox
            v-model="selectedValue.value"
            extra-class="ConsentQuestion__acceptCheck"
            @update:model-value="onChange"
        >
            {{ selectedValue.consentText }}
        </Checkbox>
    </div>
</template>

<script lang="ts">
    import { Component, Watch } from 'vue-property-decorator';

    import Checkbox from '@/components/forms/Checkbox.vue';
    import FieldComponent from '@/fields/FieldComponent';
    import StatementOfTruthWithConsent from '@/interfaces/insurance/StatementOfTruthWithConsent';
    import { defaultConsentText } from '@/utils/insuranceConsent';

    @Component({
        emits: [ 'change' ],
        components: { Checkbox },
    })
    export default class StatementOfTruth extends FieldComponent<StatementOfTruthWithConsent> {
        private selectedValue = { ...(this.value || { value: false, consentText: defaultConsentText }) };

        @Watch('value')
        private onValueChange(value: StatementOfTruthWithConsent) {
            this.selectedValue = { ...value };
        }

        private onChange() {
            this.$emit('change', { ...this.selectedValue });
        }
    }
</script>
